import React from "react";
import styled from "styled-components";
import { useAsyncFn } from "../../hooks/use-async-fn";
import { useEffect, useState } from "react";
import CertinLogo from "../../assets/certin.svg";
import Soc2Badge from "../../assets/soc_img.webp";
import IsoBadge from "../../assets/iso.webp";
import { useSidebar } from "../NewSideBar/SidebarContext";

const FooterWrapper = styled.div<{ $left: string }>`
  position: fixed;
  bottom: 0;
  left: ${({ $left }) => $left};
  right: 0;
  padding: 0.3rem var(--space-md);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--font-sm);
  color: var(--text-muted);
  transition: left 0.3s ease;
`;

interface IProps {
  fullYear: number;
  authContext: any;
  hideSideNav?: boolean;
}

const Footer = ({ authContext, fullYear, hideSideNav }: IProps) => {
  const { getApplication } = authContext;
  const { isSubSidebarCollapsed } = useSidebar();

  const getApplicationFn = useAsyncFn({
    promiseFn: getApplication,
  });

  const [staticElementFamily, setStaticElementFamily] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const applicationData = getApplicationFn.data && getApplicationFn.data;

    if (
      getApplicationFn.data &&
      applicationData &&
      applicationData.color_scheme
    ) {
      setStaticElementFamily(
        applicationData.apperance.component_settings.labels.font_type,
      );
      setLoading(false);
    }
  }, [getApplicationFn.data]);

  const leftOffset = hideSideNav
    ? "0"
    : isSubSidebarCollapsed
      ? "var(--space-5xl)"
      : "calc(var(--space-2xl) + var(--sidebar-expanded))";

  return (
    <>
      {loading ? (
        " "
      ) : (
        <FooterWrapper
          $left={leftOffset}
          style={{ fontFamily: staticElementFamily, color: "black" }}
        >
          <span>
            Powered by<strong style={{ margin: "0 0.3rem" }}>ATOM.</strong>
            Patented in USA and Singapore.
            <strong style={{ marginLeft: "0.3rem" }}>
              Copyright © {fullYear} Saptharushi Pte Ltd
            </strong>
            . All rights reserved.
          </span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexShrink: 0,
            }}
          >
            <img
              src={CertinLogo}
              alt="Cert-In"
              style={{ height: "15px", width: "auto", objectFit: "contain" }}
            />
            <img
              src={Soc2Badge}
              alt="SOC 2 Type II"
              style={{ height: "28px" }}
            />
            <img src={IsoBadge} alt="ISO" style={{ height: "28px" }} />
          </div>
        </FooterWrapper>
      )}
    </>
  );
};

export default Footer;
